/**
 * AuthResponse
 * @author Simpli CLI generator
 */
import {$, Helper, Model, Request} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Administrador} from '@/model/resource/Administrador'

/* TODO: review generated class */
export class AuthResponse extends Model {
  @ResponseSerialize(Administrador)
  administrador: Administrador | null = null

  token: string | null = null
}
